<span class="cursor-pointer text-shui-text-subtle flex items-center gap-2" id="settings-menu-selector">
    <sh-icon icon="settings" size="s" class="text-shui-text-subtle"></sh-icon>
</span>
<sh-popover target="settings-menu-selector" position="bottom">
    <sh-menu-item label="User Settings" [toggle]="false" (click)="openLink('user-settings')"></sh-menu-item>
    <sh-menu-item label="Manage Out of Office" [toggle]="false" (click)="openLink('manage-ooo')"></sh-menu-item>
    <sh-menu-item label="Calendar View" [toggle]="false" (click)="openLink('calendar-view')"></sh-menu-item>
    <sh-divider></sh-divider>
    <sh-menu-item label="Download Logs" [toggle]="false" (click)="downloadLogs()"></sh-menu-item>
</sh-popover>
